<template>
	<div class="container">
		<div class="main_top">
			<div class="main_content">
				<div class="headline">
					<p class="main_title">
						{{ $t('rtr_home.text1') }}<br />
						{{ $t('rtr_home.text2') }}<br />
						{{ $t('rtr_home.text3') }}
					</p>
					<p class="main_text">{{ $t('rtr_home.text4') }}</p>
					<button
						class="button_bg_red"
						@click="$router.push({ name: 'personal-request-send' })"
					>
						{{ $t('rtr_home.button1') }}
					</button>
				</div>
			</div>
		</div>

		<section>
			<div class="main_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_home.text5') }}<br />
								{{ $t('rtr_home.text6') }}
							</h2>
							<p class="text">
								{{ $t('rtr_home.text7') }}<br />
								{{ $t('rtr_home.text8') }}
							</p>
							<router-link :to="{ name: 'auth-register' }" class="link_type_02">
								{{ $t('rtr_home.text9') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
					<div class="img_area type_01">
						<img src="@/assets/images/main_bg_01.png" alt="" />
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="main_content">
				<div class="d_flex">
					<div class="img_area">
						<img src="@/assets/images/main_bg_02.png" alt="" />
					</div>

					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_home.text10') }}<br />
								{{ $t('rtr_home.text11') }}
							</h2>
							<p class="text">
								{{ $t('rtr_home.text12') }} {{ $t('rtr_home.text13') }}
							</p>
							<router-link :to="{ name: 'auth-register' }" class="link_type_02">
								{{ $t('rtr_home.text14') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="main_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_home.text15') }}<br />
								{{ $t('rtr_home.text16') }}
							</h2>
							<p class="text">
								{{ $t('rtr_home.text17') }}<br />
								{{ $t('rtr_home.text18') }}<br />
								{{ $t('rtr_home.text19') }}<br /><br />
								{{ $t('rtr_home.text20') }}<br />
								{{ $t('rtr_home.text21') }}<br />
								{{ $t('rtr_home.text21_1') }}
							</p>
							<router-link
								:to="{ name: 'personal-how-online_shopping' }"
								class="link_type_02"
							>
								{{ $t('rtr_home.text22') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
					<div class="img_area type_02">
						<img src="@/assets/images/main_bg_03.png" alt="" />
						<div class="bubble type_01">
							<p>{{ $t('rtr_home.text23') }}</p>
							<p>{{ $t('rtr_home.text24') }}</p>
						</div>
						<div class="bubble type_02 color">
							<p>{{ $t('rtr_home.text25') }}</p>
							<p>{{ $t('rtr_home.text26') }}</p>
						</div>
						<div class="bubble type_03">
							<p>{{ $t('rtr_home.text27') }}</p>
							<p>{{ $t('rtr_home.text28') }}</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="panel catch tac">
			<h2 class="title fc_white">{{ $t('rtr_home.text29') }}</h2>
			<p class="text fc_white fw_light">
				{{ $t('rtr_home.text30') }}<br />
				{{ $t('rtr_home.text31') }}<br />
				{{ $t('rtr_home.text32') }}
			</p>
			<button
				class="button_bg_red"
				@click="$router.push({ name: 'auth-register' })"
			>
				{{ $t('rtr_home.button2') }}
			</button>
		</section>

		<section class="type_02">
			<div class="main_content">
				<div class="detail_area">
					<div class="detail">
						<h2 class="title">
							{{ $t('rtr_home.text33') }}<br />
							{{ $t('rtr_home.text34') }}
						</h2>
						<p class="text">
							{{ $t('rtr_home.text35') }}<br />
							{{ $t('rtr_home.text36') }}<br />
							{{ $t('rtr_home.text37') }}
						</p>
						<router-link
							:to="{ name: 'business-how-start' }"
							class="link_type_02"
						>
							{{ $t('rtr_home.text38') }}
							<span class="CIRCLE_ARROW"></span>
						</router-link>
					</div>
				</div>
			</div>
			<div class="img_area prc">
				<img src="@/assets/images/main_bg_04.png" alt="" />
			</div>
		</section>

		<section class="type_02">
			<div class="img_area plc">
				<img src="@/assets/images/main_bg_05.png" alt="" />
			</div>
			<div class="main_content type_02">
				<div class="detail_area">
					<div class="detail">
						<h2 class="title">
							{{ $t('rtr_home.text39') }}
							<br />
							{{ $t('rtr_home.text40') }}
						</h2>
						<p class="text">
							{{ $t('rtr_home.text41') }} {{ $t('rtr_home.text42') }}
						</p>
						<router-link :to="{ name: 'cs' }" class="link_type_02">
							{{ $t('rtr_home.text43') }}
							<span class="CIRCLE_ARROW"></span>
						</router-link>
					</div>
				</div>
			</div>
		</section>
	</div>

	<!--	<ModalView v-if="modalPopup" @closeModal="modalPopup = false" class="popup">-->
	<!--		<div class="inner_border">-->
	<!--			<div class="popup_content">-->
	<!--				<div class="logo">-->
	<!--					<img src="@/assets/images/logo.png" alt="logo image" />-->
	<!--				</div>-->
	<!--				<h2>-->
	<!--					{{ $t('popup.title1')-->
	<!--					}}<span class="fc_red">{{ $t('popup.title2') }}</span-->
	<!--					>{{ $t('popup.title3') }}-->
	<!--				</h2>-->
	<!--				<p class="highlight">{{ $t('popup.period') }}</p>-->
	<!--				<p class="popup_text">-->
	<!--					{{ $t('popup.text1') }}<br />-->
	<!--					{{ $t('popup.text2') }}<br />-->
	<!--					{{ $t('popup.text3') }}-->
	<!--				</p>-->
	<!--			</div>-->
	<!--		</div>-->
	<!--		<div class="d_flex align_items_center">-->
	<!--			<div class="d_flex align_items_center mr_10">-->
	<!--				<input type="checkbox" id="off" class="mr_10" v-model="check" />-->
	<!--				<label for="off">{{ $t('button.not_see_today') }}</label>-->
	<!--			</div>-->
	<!--			<a class="btn_close" @click="closePopup">{{ $t('button.close') }}</a>-->
	<!--		</div>-->
	<!--	</ModalView>-->
</template>

<script>
import store from '@/store/store';
// import ModalView from '@/components/Layout/ModalView';
import Cookies from 'js-cookie';
import '@/assets/css/popup.css';

export default {
	name: 'Home',
	// components: { ModalView },
	data() {
		return {
			modalPopup: true,
			check: false,
		};
	},
	beforeRouteEnter(to, from, next) {
		if (store.getters['auth/is_logged_in']) {
			next({ name: 'auth-dashboard' });
		} else {
			next();
		}
	},
	methods: {
		closePopup() {
			if (this.check) {
				this.setCookie();
			}
			this.modalPopup = false;
		},
		setCookie() {
			Cookies.set('popup', this.check, { expires: 1 });
		},
	},
	mounted() {
		if (Cookies.get('popup')) {
			this.modalPopup = false;
		}
	},
};
</script>
